import { Injectable, Injector } from '@angular/core'
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  // HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http'
import { Observable } from 'rxjs/Observable'
import { ErrorObservable } from 'rxjs/observable/ErrorObservable'
import 'rxjs/add/operator/switchMap'

import { NbAuthService } from '../auth.service'
import { NbAuthSimpleToken } from '../token.service'

@Injectable()
export class NbAuthSimpleInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return this.authService.getToken().switchMap((token: NbAuthSimpleToken) => {
      if (token && token.getValue() && req.url.includes('/adminapi/')) {
        const currentUser = token.getValue()
        req = req.clone({
          url: `${req.url}/uid/${currentUser.id}/atoken/${currentUser.accesstoken}`,
        })
      }

      return next.handle(req).catch((err) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            // Subscribe to logout so it actually executes
            this.authService.logout('email').subscribe()
            return ErrorObservable.create(err)
          }
        }
        return ErrorObservable.create(err)
      })
    })
  }

  protected get authService(): NbAuthService {
    return this.injector.get(NbAuthService)
  }
}



// WEBPACK FOOTER //
// /srv/dev/FitRadioAdmin2/src/app/@nebular/auth/services/interceptors/simple-interceptor.ts